import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

interface FooterLink {
  label: string;
  path: string;
}

@Component({
  imports: [RouterLink, TranslocoDirective],
  selector: 'app-footer',
  styleUrl: './footer.css',
  templateUrl: './footer.html',
})
export class Footer {
  protected readonly year = new Date().getFullYear();

  protected readonly links: FooterLink[] = [
    // { label: 'Home', path: '/' },
    // { label: 'Login', path: '/login' },
  ];
}
